import Compressor from 'compressorjs';
import {toBase64, getFileSizeMB} from 'utils/common';
import {
  IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB,
  IDENTITY_VERIFICATION_PHOTOS_QUALITY,
} from 'utils/constants';

export const compressImage = (image: File) => {
  const parsedImage = new File([image], image.name, {type: image.type});

  return new Promise<string>((resolve, reject) => {
    new Compressor(parsedImage, {
      convertSize: IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB * 1000000,
      quality: IDENTITY_VERIFICATION_PHOTOS_QUALITY,
      success: (compressedResult: File) => {
        toBase64(compressedResult).then(result => {
          console.log(
            'Before: ',
            getFileSizeMB(image)?.toFixed(2),
            'MB',
            'After: ',
            getFileSizeMB(compressedResult)?.toFixed(2),
            'MB',
          );
          resolve(result);
        });
      },
      error: reject,
    });
  });
};
